import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import {getStorage} from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyCj_r0gEIzC-dtNUzwvaGoRjDrTUz0GrTo",
    authDomain: "qdataapp.firebaseapp.com",
    databaseURL: "https://qdataapp-default-rtdb.firebaseio.com",
    projectId: "qdataapp",
    storageBucket: "qdataapp.appspot.com",
    messagingSenderId: "433971281985",
    appId: "1:433971281985:web:742740a0e47a3f9e6c86c0",
    measurementId: "G-YY0H4LKTFQ"
  };

  const app = initializeApp(firebaseConfig);
  export const auth = getAuth(app);
  export const database = getDatabase(app);
  export const storage = getStorage(app);
  // export default app